module.exports = __webpack_public_path__ + "static/img/logo-1.747d7de8.png";